module.exports = __webpack_public_path__ + "static/media/headerimage.b984fbfd.jpg";